module.exports = __webpack_public_path__ + "img/HR78427478595.679c43bf.png";